const storeName = 'WISHLIST';

export default {
    SET_LOADING: `${storeName}.SET_LOADING`,
    LOADING_FINISHED: `${storeName}.LOADING_FINISHED`,
    CREATE_WISHLIST: `${storeName}.CREATE_WISHLIST`,
    LOAD_WISHLIST: `${storeName}.LOAD_WISHLIST`,
    ADD_TO_WISHLIST: `${storeName}.ADD_TO_WISHLIST`,
    ADD_TO_SELECTED_WISHLIST: `${storeName}.ADD_TO_SELECTED_WISHLIST`,
    REMOVE_FROM_WISHLIST: `${storeName}.REMOVE_FROM_WISHLIST`,
    UPDATE_WISHLIST: `${storeName}.UPDATE_WISHLIST`,
    UPDATE_PERSONAL_WISHLIST: `${storeName}.UPDATE_PERSONAL_WISHLIST`,
    UPDATE_SHARED_WISHLIST: `${storeName}.UPDATE_SHARED_WISHLIST`,
    SET_WISHLIST: `${storeName}.SET_WISHLIST`,
    SET_SHARED_WISHLIST: `${storeName}.SET_SHARED_WISHLIST`,
    MOVE_TO_CART: `${storeName}.MOVE_TO_CART`,
    ADD_TO_CART: `${storeName}.ADD_TO_CART`,
    LOAD_SELECTED_WISHLIST: `${storeName}.LOAD_SELECTED_WISHLIST`,
    LOAD_NEW_WISHLIST: `${storeName}.LOAD_NEW_WISHLIST`,
    SHARE_WISHLIST: `${storeName}.SHARE_WISHLIST`,
    FILTER_WISHLIST: `${storeName}.FILTER_WISHLIST`,
    SET_FILTER: `${storeName}.SET_FILTER`,
    SET_NEW_WISHLIST_DATA: `${storeName}.SET_NEW_WISHLIST_DATA`,
    RESET_NEW_WISHLIST_DATA: `${storeName}.RESET_NEW_WISHLIST_DATA`,
    REMOVE_WISHLIST: `${storeName}.REMOVE_WISHLIST`,
    SET_INITIAL: `${storeName}.SET_INITIAL`,
    SET_PENDING_PRODUCT: `${storeName}.SET_PENDING_PRODUCT`,
    REMOVE_PENDING_FROM_WISHLIST: `${storeName}.REMOVE_PENDING_FROM_WISHLIST`,
    RENAME_WISHLIST: `${storeName}.RENAME_WISHLIST`,
    ADD_ALL_PRODUCTS_TO_CART: `${storeName}.ADD_ALL_PRODUCTS_TO_CART`,
    ADD_ALL_SHARED_WISHLIST_PRODUCTS_TO_CART: `${storeName}.ADD_ALL_SHARED_WISHLIST_PRODUCTS_TO_CART`,
    SET_NEW_WISHLIST_ANALYSTICS_DATA: `${storeName}.SET_NEW_WISHLIST_ANALYSTICS_DATA`,
    CALCULATE_TOTAL_WITH_MEMBER_PRICE: `${storeName}.CALCULATE_TOTAL_WITH_MEMBER_PRICE`,
    SET_ERROR_WHILE_ADD_TO_WISHLIST: `${storeName}.SET_ERROR_WHILE_ADD_TO_WISHLIST`,
    OPEN_SHARE_WISHLIST_DIALOG: `${storeName}.OPEN_SHARE_WISHLIST_DIALOG`,
    SET_ERROR_STATE_FOR_SHARED_WISHLIST: `${storeName}.SET_ERROR_STATE_FOR_SHARED_WISHLIST`,
    SET_LIGHT_WISHLIST: `${storeName}.SET_LIGHT_WISHLIST`,
    LOAD_LIGHT_WISHLIST: `${storeName}.LOAD_LIGHT_WISHLIST`,
};
